function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.733 6.51741L13.6193 0.272768C13.4489 0.0986608 13.2188 0 12.9773 0H0.909091C0.40625 0 0 0.414955 0 0.928571V25.0714C0 25.585 0.40625 26 0.909091 26H19.0909C19.5938 26 20 25.585 20 25.0714V7.17612C20 6.92946 19.9034 6.69152 19.733 6.51741ZM12.5568 2.14152L17.9034 7.60268H12.5568V2.14152ZM17.9545 23.9107H2.04545V2.08929H10.625V8.35714C10.625 8.68038 10.7507 8.99037 10.9745 9.21893C11.1982 9.44749 11.5017 9.57589 11.8182 9.57589H17.9545V23.9107Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.50071 11.9571C7.37571 11.9542 7.27344 12.0587 7.27344 12.1863V20.1953C7.27344 20.3229 7.37571 20.4274 7.50071 20.4274H8.42401C8.54901 20.4274 8.65128 20.3229 8.65128 20.1953V17.4241H10.4496C12.1371 17.4241 13.1825 16.2953 13.1825 14.6935C13.1825 13.112 12.1513 11.9571 10.4553 11.9571H7.50071ZM11.7791 14.6906C11.7791 15.9499 11.0263 16.2662 9.75639 16.2662H8.65128V13.1207H10.2479C11.2081 13.1207 11.7791 13.6924 11.7791 14.6906Z",
  fill: "currentColor"
});

var SvgIcPowerpoint = function SvgIcPowerpoint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPowerpoint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_powerpoint.174c3c81.svg";
export { ForwardRef as ReactComponent };